<template>
  <div class="page-view box-card">
    <div class="box-card-header">
      <router-link class="kg-btn1" :to="{ name: 'userTransferRecord' }">
        <I18Lang id="my28" defaultText="转账记录" />
      </router-link>
    </div>

    <div class="box-card-content">
      <el-form
        :model="formData"
        ref="formData"
        :rules="rules"
        class="reset-from"
      >
        <el-form-item label="转账类型：">
          <template slot="label">
            <I18Lang id="my129" defaultText="转账类型" />：
          </template>
          <el-radio-group
            v-model="formData.transfer_type"
            @change="transferTypeChange"
          >
            <el-radio :label="1">
              <I18Lang id="usermoney28" defaultText="交易账户转账" />
            </el-radio>
            <el-radio :label="2">
              <I18Lang id="usermoney29" defaultText="代理转账" />
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <template v-if="formData.transfer_type === 1">
          <el-form-item label="转账操作：">
            <template slot="label">
              <I18Lang id="user115" defaultText="Transfer Direction" />：
            </template>
            <el-radio-group v-model="formData.transfer_operation">
              <el-radio :label="1">
                <I18Lang id="usermoney31" defaultText="转入" />
              </el-radio>
              <el-radio :label="2">
                <I18Lang id="usermoney32" defaultText="转出" />
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </template>

        <div class="line"></div>

        <div class="form-view">
          <div class="form-view-left">
            <template v-if="formData.transfer_type === 1">
              <el-form-item label="交易账户：" prop="accountIndex">
                <template slot="label">
                  <I18Lang id="usermoney36" defaultText="交易账户" />：
                </template>
                <el-select
                  v-model="formData.accountIndex"
                  :placeholder="$t('public24')"
                  @change="accountChange"
                >
                  <el-option
                    v-for="(item, key) in accountList"
                    :label="
                      (item.trade_model === 0 ? $t('user42') : $t('user45')) +
                      ' - ' +
                      item.account_no
                    "
                    :value="key"
                    :key="key"
                  ></el-option>
                </el-select>
              </el-form-item>

              <div class="form-item">
                <div class="form-item-label">
                  <I18Lang id="user32" defaultText="现金账户余额($)" />
                </div>
                <div class="form-item-value">{{ transferInfo.balance }}</div>
              </div>

              <div class="form-item">
                <div class="form-item-label">
                  <I18Lang id="public51" defaultText="交易账户余额" />(MEQ)
                </div>
                <div class="form-item-value">{{ currentAccount.balance }}</div>
              </div>
            </template>

            <template v-else>
              <div class="form-item">
                <div class="form-item-label">
                  <I18Lang id="usermoney33" defaultText="转账代理ID" />
                </div>
                <div class="form-item-value">{{ parentInfo.account_id }}</div>
              </div>

              <div class="form-item">
                <div class="form-item-label">
                  <I18Lang id="usermoney35" defaultText="转账对象姓名" />
                </div>
                <div class="form-item-value">{{ parentInfo.username }}</div>
              </div>

              <div class="form-item">
                <div class="form-item-label">
                  <I18Lang id="usermoney6" defaultText="现金账户" />
                </div>
                <div class="form-item-value">{{ transferInfo.balance }}</div>
              </div>

            </template>
          </div>
          <div class="form-view-right">
            <el-form-item label="转账金额($)" prop="amount">
              <template slot="label">
                <I18Lang id="my68" defaultText="转账金额($)" />
              </template>
              <el-input
                type="number"
                @input="inputNum"
                class="reset-input"
                v-model="formData.amount"
                :placeholder="$t('usermoney43')"
              ></el-input>
              <!--
              <p class="rate-text" v-if="formData.transfer_type === 1">
                <I18Lang id="public52" defaultText="当前的汇率是" />：
                <i class="cr-red">{{ transferInfo.exchange_rate }}</i>
              </p>-->
            </el-form-item>

            <!--
            <div class="form-item" v-if="formData.transfer_type === 1">
              <div class="form-item-label">
                <I18Lang id="my39" defaultText="转账金额" />(MEQ)
                ({{ currMarket }})
              </div>
              <div class="form-item-value">{{ usdMoney }}</div>
            </div>-->
          </div>
        </div>

        <el-form-item class="footer-btn">
          <div
            :loading="isSubmitLoading"
            class="btn-submit kg-btn2"
            @click="submitForm('formData')"
          >
            <I18Lang id="my22" defaultText="立即提交" />
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { fileDomain } from '@utils'
import { mapState } from 'vuex'

export default {
  name: 'home',
  data () {
    return {
      fileDomain,
      isSubmitLoading: false,
      transferInfo: {}, // 转账信息
      accountList: [],
      currentAccount: {},
      parentInfo: {},
      accountInfo: {},
      formData: {
        accountIndex: '',
        amount: '',
        transfer_type: 1,
        transfer_operation: 1,
        trade_account_no: '',
        trade_account_mode: '',
        exchange_rate: ''
      },
      rules: {
        accountIndex: [
          {
            required: true,
            message: this.$t('public24'),
            trigger: 'change'
          }
        ],
        amount: [
          {
            required: true,
            message: this.$t('usermoney43'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getAccountInfo()
    this.getAccountList()
    this.getTransferInfo()
    if (this.$route.query.type) {
      const type = this.$route.query.type
      if (type === 'deposit') {
        this.formData.transfer_type = 1
        this.formData.transfer_operation = 1
      } else {
        this.formData.transfer_type = 1
        this.formData.transfer_operation = 2
      }
    }
  },
  methods: {
    inputNum () {
      // eslint-disable-next-line no-useless-escape
      this.formData.amount = this.formData.amount.replace(
        /^(\-)*(\d+)\.(\d\d).*$/,
        '$1$2.$3'
      )
    },
    getBit (value, bit = 3) {
      let str = value.toString()
      const strIndex = str.indexOf('.')
      if (strIndex === -1) return str
      str = str.substring(0, strIndex + bit)
      console.log(str, bit)
      return str
    },
    getTransferInfo () {
      // 获取转账信息
      this.$http.post('/api/cash/transferInfo').then((result) => {
        this.transferInfo = result
        this.formData.exchange_rate = result.exchange_rate
      })
    },
    getAccountInfo () {
      this.$http.get('/api/account/info').then((result) => {
        this.accountInfo = result
      })
    },
    getAccountList () {
      this.$http
        .get('/api/account/list', { params: { available: 1 } })
        .then((result) => {
          this.accountList = result
          const requested = String(this.$route.query.trade_account_no || '')
          const selected = requested ? result.findIndex(x => String(x.account_no) === requested) : -1
          if (selected >= 0) {
            this.formData.accountIndex = selected
            this.accountChange(selected)
          }
        })
    },
    transferTypeChange () {
      this.$http.get('/api/user/parent').then((result) => {
        this.parentInfo = result
      })
    },
    accountChange (val) {
      this.currentAccount = this.accountList[val]
      if (this.accountList[val]) {
        this.formData.trade_account_no = this.accountList[val].account_no
        this.formData.trade_account_mode = this.accountList[val].trade_model
      }
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return

        if (this.isCashBalanceInsufficient()) {
          this.showCashBalanceError()
          return
        }

        this.submit()
      })
    },
    isCashBalanceInsufficient () {
      const amount = Number(this.formData.amount || 0)
      const cashBalance = Number(this.transferInfo.balance || 0)
      const isCashAccountTransfer = this.formData.transfer_type === 2 ||
        (this.formData.transfer_type === 1 && this.formData.transfer_operation === 1)

      return isCashAccountTransfer && amount > cashBalance
    },
    showCashBalanceError () {
      this.$alert(this.$t('transferbalance1'), {
        confirmButtonText: this.$t('my25'),
        center: true,
        customClass: 'warning-alert'
      })
    },
    submit () {
      this.isSubmitLoading = true
      const params = this.formData
      delete params.accountIndex
      this.$http
        .post('/api/cash/userTransfer', params)
        .then((result) => {
          this.$alert('<h3>Transfer successful</h3>', '', {
            confirmButtonText: this.$t('my25'),
            center: true,
            dangerouslyUseHTMLString: true,
            customClass: 'success-alert',
            callback: (action) => {
              if (this.formData.transfer_type === 1) {
                this.$router.push({ name: 'userTransferRecord' })
              } else {
                this.$router.push({ name: 'userAgentTransfer' })
              }
            }
          })
          this.isSubmitLoading = false
        })
        .catch(() => {
          this.isSubmitLoading = false
        })
    }
  },
  computed: {
    usdMoney () {
      if (!this.transferInfo.exchange_rate || !this.formData.amount) {
        return 0
      }
      const val = this.transferInfo.exchange_rate * this.formData.amount
      return this.getBit(val, 5)
    },
    ...mapState(['userInfo', 'currMarket', 'currCountryInfo'])
  }
}
</script>
<style scoped lang="scss">
.page-view {
  padding-top: 50px;
  padding-bottom: 100px;

  .box-card-header {
    width: 936px;
    margin: 0 auto;
    display: flex;
    justify-content: end;

    .kg-btn1 {
      width: 188px;
      margin-right: -6px;
      margin-bottom: 3px;
    }
  }

  .box-card-content {
    background: url("../../../assets/img/k.png") no-repeat center / 100% 100%;
    width: 936px;
    margin: 0 auto;
    padding-top: 88px;
    padding-left: 80px;
    padding-right: 80px;
    padding-bottom: 50px;

    .line {
      width: 100%;
      height: 1px;
      background: #00ccff;
      opacity: 0.3;
      margin-bottom: 44px;
    }

    .form-view {
      display: flex;
      justify-content: space-between;

      .form-view-left {
      }

      .form-view-right {
      }
    }

    .reset-from {
      .form-item {
        margin-bottom: 35px;

        .form-item-label {
          font-size: 16px;
          font-weight: 400;
          color: #01b2f5;
        }

        .form-item-value {
          font-size: 18px;
          font-weight: bold;
          color: #ffffff;
        }
      }

      ::v-deep .el-form-item {
        margin-bottom: 40px;

        .el-form-item__label {
          font-size: 16px;
          font-family: Arial;
          font-weight: 400;
          color: #01b2f5;
          display: block;
          text-align: left;
          float: none;
        }

        .el-input__inner {
          width: 319px;
          height: 34px;
          border: 1px solid rgba(1, 178, 245, 0.5);
          line-height: 34px;
          background: transparent;
          color: #fff;
          border-radius: 0;
        }

        .el-radio__inner {
          background: #000;
          width: 20px;
          height: 20px;
          border: 1px solid rgba(1, 178, 245, 0.5);
        }

        .el-radio__label {
          color: #fff;
        }

        .el-radio__input.is-checked .el-radio__inner {
          border: 4px solid #01b2f5;

          &::after {
            display: none;
          }
        }
      }

      .btn-submit {
        width: 110px;
        height: 55px;
        line-height: 55px;
        margin-left: -10px;
      }
    }

    .footer-btn {
      text-align: center;
    }
  }
}

.rate-text {
  padding-top: 12px;
  padding-left: 10px;
  font-size: 12px;
  font-weight: 400;
  color: #c9c9c9;
  line-height: 15px;

  i {
    font-size: 14px;
    font-weight: bold;
    color: #01b2f5;
  }
}

@media only screen and (max-width: 755px) {
  .page-view {
    padding-top: 50px;
    padding-bottom: 100px;

    .box-card-header {
      width: auto;
      margin: 0 auto;
      display: flex;
      justify-content: end;

      .kg-btn1 {
        width: 188px;
        margin-right: -6px;
        margin-bottom: 3px;
      }
    }

    .box-card-content {
      background: none;
      width: auto;
      margin: 0 auto;
      padding-top: 88px;
      padding-left: 80px;
      padding-right: 80px;
      padding-bottom: 50px;

      .line {
        width: 100%;
        height: 1px;
        background: #00ccff;
        opacity: 0.3;
        margin-bottom: 44px;
      }

      .form-view {
        display: block;
        justify-content: space-between;

        .form-view-left {
        }

        .form-view-right {
        }
      }

      .reset-from {
        .form-item {
          margin-bottom: 35px;

          .form-item-label {
            font-size: 20px;
            font-weight: 400;
            color: #01b2f5;
          }

          .form-item-value {
            font-size: 20px;
            font-weight: bold;
            color: #ffffff;
          }
        }

        ::v-deep .el-form-item {
          margin-bottom: 40px;

          .el-form-item__label {
            font-size: 20px;
            font-family: Arial;
            font-weight: 400;
            color: #01b2f5;
            margin-bottom: 20px;
          }

          .el-input__inner {
            width: 100%;
            height: 60px;
            font-size: 18px;
            border: 1px solid rgba(1, 178, 245, 0.5);
            line-height: 60px;
            background: transparent;
            color: #fff;
            border-radius: 0;
          }

          .el-form-item__error {
            font-size: 16px;
          }

          .el-radio {
            margin-bottom: 20px;
          }

          .el-radio__label {
            color: #fff;
            font-size: 20px;
          }

          .el-select {
            display: block;
          }

          .el-radio__input.is-checked .el-radio__inner {
            border: 4px solid #01b2f5;

            &::after {
              display: none;
            }
          }
        }

        .btn-submit {
          width: 210px;
          height: 85px;
          line-height: 85px;
          font-size: 20px;
          margin-left: -10px;
        }
      }

      .footer-btn {
        text-align: center;
      }
    }
  }

  .rate-text {
    padding-top: 12px;
    padding-left: 10px;
    font-size: 16px;
    font-weight: 400;
    color: #c9c9c9;
    line-height: 15px;

    i {
      font-size: 16px;
      font-weight: bold;
      color: #01b2f5;
    }
  }
}
</style>
